export const selectInterviewReportsFilters = (state) =>
  state?.interviewReports?.filters;
export const selectInterviewReportsFilterWithValues = (state) =>
  state?.interviewReports?.filterWithvalues;
export const selectInterviewReportsTimeFrame = (state) =>
  state?.interviewReports?.time;
export const selectInterviewReportsGroup = (state) =>
  state?.interviewReports?.group;

export const selectInterviewCard = (state) => state?.interviewReports?.cards;
export const selectInterviewCardLoading = (state) =>
  state?.interviewReports?.isCardLoading;

export const selectInterviewVisual = (state) =>
  state?.interviewReports?.interviewVisuals;
export const selectInterviewVisualIsLoading = (state) =>
  state?.interviewReports?.isInterviewVisualsLoading;

export const selectInterviewChart = (state) => state?.interviewReports?.chart;
export const selectInterviewTable = (state) => state?.interviewReports?.table;
export const selectInterviewChartLoading = (state) =>
  state?.interviewReports?.isChartLoading;
export const selectInterviewTableLoading = (state) =>
  state?.interviewReports?.isTableLoading;
